const price = (function() {
    // end/emboss PRICING tables kept for any future per-option pricing
    const END_PRICES    = {};
    const EMBOSS_PRICES = {};

    function calculate() {
        const s = state.getState();
        const strapPrice      = s.strapPrice  || 0;
        const innerStrapPrice = s.isDouble ? (s.innerStrapPrice || 0) : 0;
        const bucklePrice     = s.bucklePrice || 0;
        const craftFee        = getCraftFee(s.stitch);
        const total = strapPrice + innerStrapPrice + bucklePrice + craftFee;
        return { strapPrice, innerStrapPrice, bucklePrice, craftFee, total };
    }

    function getCraftFee(stitch) {
        // stitch format: "Fully stitched / Red / Thick Thread" or "No-stitch"
        const stitchType = (stitch || '').split(' / ')[0].trim() || 'No-stitch';
        const map = (typeof window !== 'undefined' && window.__beltPriceMap) || {};
        return map[stitchType] ?? 30;
    }

    function format(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        }).format(amount || 0);
    }

    return { calculate, format, getCraftFee };
})();
